import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
import { useScrollProgress } from '../../hooks/useScrollProgress';
export function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const progress = useScrollProgress();
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const circumference = 2 * Math.PI * 18;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  return <AnimatePresence data-id="element-189">
      {isVisible && <motion.button initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.8
    }} onClick={scrollToTop} className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-40 group" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-190">
          <div className="relative w-12 h-12 sm:w-14 sm:h-14" data-id="element-191">
            {/* Progress ring */}
            <svg className="w-full h-full -rotate-90" data-id="element-192">
              <circle cx="50%" cy="50%" r="18" stroke="currentColor" strokeWidth="2" fill="none" className="text-stone/20" data-id="element-193" />
              <circle cx="50%" cy="50%" r="18" stroke="currentColor" strokeWidth="2" fill="none" className="text-gold transition-all duration-300" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" data-id="element-194" />
            </svg>

            {/* Button */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-195">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-charcoal flex items-center justify-center group-hover:bg-gold transition-colors duration-300" data-id="element-196">
                <ArrowUp size={20} className="text-white group-hover:text-charcoal transition-colors" strokeWidth={2} data-id="element-197" />
              </div>
            </div>
          </div>
        </motion.button>}
    </AnimatePresence>;
}